import React from 'react'

export default function AdminChatPage() {
  return (
    <div>
      
    </div>
  )
}
